import * as React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { TaxonomyProjectType } from '../../../../types/uncinc_profile/taxonomy';

interface TaxonomyProjectTypePageProps {
  entity: ImmutableEntity<TaxonomyProjectType>;
}

const TaxonomyPage: React.FC<TaxonomyProjectTypePageProps> = ({ entity }) => {
  const taxonomy = entity.toJS();
  const name = taxonomy.name[0].value;
  const body = taxonomy.description[0].value;

  return (
    <div className="TaxonomyProjectTypePage">
      <h1 className="TaxonomyProjectTypePage__title">{name}</h1>
      <WysiwygField html={body} className="TaxonomyProjectTypePage__body" />
    </div>
  );
};

export default TaxonomyPage;
